// @ts-check

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// state
import { useAppDispatch, useAppSelector } from 'core/store';
import {
  getCampaignAsync,
  getExportFiltersAsync,
  getFiltersAsync,
} from 'core/store/slices';

const useStateExportFilters = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.queryBuilder);

  useEffect(() => {
    if (filters?.length > 0) return;

    dispatch(getExportFiltersAsync());
  }, [filters, dispatch]);
};

const useStateFilters = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.queryBuilder);

  useEffect(() => {
    if (filters?.length > 0) return;

    dispatch(getFiltersAsync());
  }, [filters, dispatch]);
};

const useStateCampaign = () => {
  const dispatch = useAppDispatch();
  const reloadData = useAppSelector((state) => state.campaignData.reloadData);
  const loadedCampaignId = useAppSelector(
    (state) => state.campaignData.campaign.campaignId,
  );
  // campaignLogic contains the query logic/rules (filters that define the matches).
  // Detect whether the campaign data has actually been loaded with content.
  // If undefined/null, campaign object exists but is empty/reset (missing data).
  // If missing, fetch to reload the complete campaign data from the server.
  // This will prevent Details page from showing empty fields.
  const campaignLogic = useAppSelector(
    (state) => state.campaignData.campaign.logic,
  );

  /** @type {{ id: string }} */
  let { id: campaignId } = useParams();
  useEffect(() => {
    if (!campaignId || !reloadData) {
      return;
    }

    // Fetch if campaign ID doesn't match route ID, OR if the campaign data
    // is missing (e.g., cleared/reset but campaignId wasn't updated)
    if (loadedCampaignId !== campaignId || campaignLogic === undefined) {
      dispatch(
        getCampaignAsync({
          campaignId,
        }),
      );
    }
  }, [campaignId, campaignLogic, dispatch, reloadData, loadedCampaignId]);
};

export { useStateCampaign, useStateExportFilters, useStateFilters };
